import { noop } from "lodash";
import React, { PropsWithChildren, createContext, useContext, useState } from "react";

//временный протез
const BuildingInvalidateKeyContext = createContext({
  shouldUpdate: false,
  revalidate: noop,
  // присоединяюсь к протезу, голосую за context для Building
  isTemplatePending: false,
  appendTemplatePendingBackendTask: noop,
  removeTemplatePendingBackendTask: noop,
});

export const BuildingInvalidateKeyContextProvider = ({ children }: PropsWithChildren) => {
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [templatePendingBackendTasks, setTemplatePendingBackendTasks] = useState<string[]>([]);

  const isTemplatePending = templatePendingBackendTasks.length > 0;

  const appendTemplatePendingBackendTask = (taskId: string) => {
    setTemplatePendingBackendTasks((prev) => [...prev, taskId]);
  };

  const removeTemplatePendingBackendTask = (taskId: string) => {
    setTemplatePendingBackendTasks((prev) => prev.filter((id) => id !== taskId));
  };

  const revalidate = () => {
    setShouldUpdate(true);
    setTimeout(() => {
      setShouldUpdate(false);
    }, 100);
  };

  return (
    <BuildingInvalidateKeyContext.Provider
      value={{
        shouldUpdate,
        revalidate,
        isTemplatePending,
        appendTemplatePendingBackendTask,
        removeTemplatePendingBackendTask,
      }}
    >
      {children}
    </BuildingInvalidateKeyContext.Provider>
  );
};

export const useBuildingInvalidateKeyContext = () => useContext(BuildingInvalidateKeyContext);
